module.exports = __webpack_public_path__ + "static/media/night.a3f3f38d.svg";